import type {
  User,
  Namespace,
} from '@gymcloud/core';

import {
  Flex,
  TextBold,
} from 'web-styled';

import Pro from './Pro';
import Client from './Client';
import Trainer from './Trainer';
import Activity from './Activity';
import * as S from './styled';

type Props = {
  profile: User,
  namespace: Namespace;
};

const Dashboard = ({
  profile,
  namespace,
}: Props) => {
  const isPro = profile.is_pro;

  const trainerVisible = !isPro && namespace.symbol === 'gymcloud';

  return (
    <Flex fillSpace column>
      <S.Header>
        <TextBold color="#fff" size="30px">
          Dashboard
        </TextBold>
        {trainerVisible && <Trainer />}
      </S.Header>
      <Flex fillSpace scrollY>
        {isPro ? <Pro /> : <Client />}
        <Flex flex="0 0 236px">
          {(namespace.symbol !== 'ideafit') && (
            <S.RightSide>
              <Activity />
            </S.RightSide>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Dashboard;
